/**
 * Convert an integer, like 1, to ordinal, like 1st.
 * @param {number} x
 * @returns {string} 1st, 2nd, 3rd, etc...
 */
export function ordinal(x: number): string {
  return x + (~~(x / 10) % 10 === 1 ? 'th' : ['', 'st', 'nd', 'rd'][x % 10] || 'th');
}
